module.exports = __webpack_public_path__ + "static/media/floral-design-corner-ornamental-shape-svgrepo-com.a7ccc529.svg";